<template>
  <rapi-doc
    :goto-path="goToHash"
    :spec-url="docUrl"
    render-style="read"
    v-bind="{ ...config }"
  />
</template>

<script>
import "rapidoc";

export default {
  name: "ApiDoc",
  components: {},
  props: {
    goToHash: {
      type: String,
      default: undefined
    },
    apiName: {
      type: String,
      default: ""
    },
    docUrl: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => {
        return {
          theme: "dark",
          "primary-color": "#ffc000",
          "regular-font": "'Roboto'",
          "mono-font": "'Roboto Mono'",
          "render-style": "read",
          "show-header": "false",
          style: "height:100vh; width:100%",
          "schema-description-expanded": "true",
          "show-components": "true"
        };
      }
    }
  },
  data() {
    return {};
  }
};
</script>
